import React, { useState, useContext, useRef } from 'react';
import { dispatch, useDispatch } from '../../store/index.js';
import { ChangePage } from '../../store/reducers/menu.js';
import { useSelector } from '../../store/index.js';
import { useEffect } from 'react';
import loading from "../../utils/Loading.js";
import { Logout, Login } from '../../store/reducers/auth.js';
import { BASE_URL } from '../../config.js';
import useApi from "../../hooks/useApi.js";
import { useParams } from "react-router-dom";
import { CloseIcon, LeftIcon, RightIcon } from '../../icons/index.js';
import toast from 'react-hot-toast';
import { useReducedMotion } from 'framer-motion';
import { showLoading, hideLoading } from '../../store/reducers/load.js';

function BonusClaimModal() {
    const dispatch = useDispatch();
    const [bonusInfo, setBonusInfo] = useState(null);
    const [teamInfo, setTeamInfo] = useState([]);

    const { user } = useSelector((state) => (state.auth));
    const { getBonusInfoAPI, applyAllBonusAPI } = useApi();

    const [activeTab, setActiveTab] = useState("level1");

    const handleTabChange = (index) => {
        setActiveTab(index);
    };

    const getBonusInfo = async () => {
        try {
            const result = await getBonusInfoAPI({ userId: user._id })

            setBonusInfo(result.data.data[0]);
        } catch {
        }
    }


    const applyAllBonus = async () => {
        try {
            dispatch(showLoading({ open: true }));

            const result = await applyAllBonusAPI({ userId: user._id });

            dispatch(hideLoading());

            dispatch(ChangePage(""))

            if (result.data.success) {
                toast.success(result.data.msg);
            } else {
                toast.warning(result.data.msg);
            }
        } catch {
            toast.error("Network Connection Error")
        }
    }

    useEffect(() => {
        getBonusInfo();
    }, [])

    return (
        <div className="modal-overlay fixed inset-0 flex items-center justify-center text-white z-50" style={{ backgroundColor: "rgba(0,0,0,0.9)" }}>
            <div className="fixed inset-0 flex items-center justify-center">
                <div className="flex w-full flex-row justify-center items-center px-4">
                    <div style={{ maxWidth: "628px", maxHeight: '666px', margin: '0 auto' }} className='w-full gap-[40px] flex justify-startitems-center md:px-4 grid grid-cols-1'>
                        <div className="w-full flex flex-col gap-[20px] bg-primary bg-opacity-90">
                            <div className="flex w-full flex-col justify-center items-center ">
                                <div className="w-full bg-opacity-40 p-4 md:p-8 rounded-lg flex justify-center gap-4 flex-col items-center rounded-5 shadow-bottom_2">
                                    <div className='w-full flex flex-row justify-end items-center pb-1'>
                                        <div className="text-white font-plus font-bold text-18 leading-22 flex flex-row w-full justify-end items-end cursor-pointer" onClick={() => dispatch(ChangePage(""))}><CloseIcon /></div>
                                    </div>
                                    <div className="relative flex flex-col justify-start w-full gap-3">
                                        <div className="flex flex-col justify-center items-center w-full">
                                            <ul className="flex w-full flex-row text-sm font-medium text-center text-gray-500 dark:text-gray-400">
                                                <li className="me-2 w-full" onClick={() => handleTabChange("level1")}>
                                                    <a href="#" className={`inline-block px-2 md:px-4 py-3 w-full rounded-lg font-bold text-24 hover:text-gray-900 dark:hover:text-white ${activeTab == "level1" ? 'text-white bg-yellow-300' : ''}`} aria-current="page">Level 1</a>
                                                </li>
                                                <li className="me-2 w-full" onClick={() => handleTabChange("level2")}>
                                                    <a href="#" className={`inline-block px-2 md:px-4 py-3 w-full rounded-lg font-bold text-24 hover:text-gray-900 dark:hover:text-white ${activeTab == "level2" ? 'text-white bg-yellow-300' : ''}`} aria-current="page">Level 2</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="flex flex-row w-full px-4 pt-2 justify-around items-center">
                                            <div className="flex flex-col justify-center items-center gap-4">
                                                <span className="font-plus font-normal">Registration</span>
                                                <span className="font-plus font-bold">{activeTab == "level1" ? (bonusInfo ? bonusInfo?.level1Users : 0) : (bonusInfo ? bonusInfo?.level2Users : 0)}</span>
                                            </div>
                                            <div className="flex flex-col justify-center items-center gap-4">
                                                <span className="font-plus font-normal">Bonus</span>
                                                <span className="font-plus font-bold">$ {activeTab == "level1" ? (bonusInfo ? bonusInfo?.level1 : 0) : (bonusInfo ? bonusInfo?.level2 : 0)}</span>
                                            </div>
                                        </div>

                                        <div className="flex flex-row w-full px-4 pt-2 justify-center items-center">
                                            <span className="font-plus font-normal text-20">Available Bonus:&nbsp;&nbsp;</span>
                                            <span className="font-plus font-bold text-center text-20">$ {bonusInfo ? bonusInfo.amount : 0}</span>
                                        </div>
                                    </div>
                                    <div className="flex flex-row justify-between items-center wrap gap-[30px] w-[231px] pt-2">
                                        <a className="text-12 px-4 py-4 font-medium btn-primary rounded-lg w-full flex flex-row justify-center gap-45 items-center" onClick={() => applyAllBonus()}
                                            style={{ textAlign: 'center', cursor: 'pointer' }}>
                                            <p className='text-gray-900 font-bold'>Apply to balance</p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BonusClaimModal;